'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _languageHandler = require('../../../languageHandler');

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageComposerFormatBar = function (_React$PureComponent) {
    (0, _inherits3.default)(MessageComposerFormatBar, _React$PureComponent);

    function MessageComposerFormatBar(props) {
        (0, _classCallCheck3.default)(this, MessageComposerFormatBar);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MessageComposerFormatBar.__proto__ || (0, _getPrototypeOf2.default)(MessageComposerFormatBar)).call(this, props));

        _this.state = { visible: false };
        return _this;
    }

    (0, _createClass3.default)(MessageComposerFormatBar, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var classes = (0, _classnames2.default)("mx_MessageComposerFormatBar", {
                "mx_MessageComposerFormatBar_shown": this.state.visible
            });
            return _react2.default.createElement(
                'div',
                { className: classes, ref: function ref(_ref) {
                        return _this2._formatBarRef = _ref;
                    } },
                _react2.default.createElement(FormatButton, { label: (0, _languageHandler._t)("Bold"), onClick: function onClick() {
                        return _this2.props.onAction("bold");
                    }, icon: 'Bold', shortcut: this.props.shortcuts.bold, visible: this.state.visible }),
                _react2.default.createElement(FormatButton, { label: (0, _languageHandler._t)("Italics"), onClick: function onClick() {
                        return _this2.props.onAction("italics");
                    }, icon: 'Italic', shortcut: this.props.shortcuts.italics, visible: this.state.visible }),
                _react2.default.createElement(FormatButton, { label: (0, _languageHandler._t)("Strikethrough"), onClick: function onClick() {
                        return _this2.props.onAction("strikethrough");
                    }, icon: 'Strikethrough', visible: this.state.visible }),
                _react2.default.createElement(FormatButton, { label: (0, _languageHandler._t)("Code block"), onClick: function onClick() {
                        return _this2.props.onAction("code");
                    }, icon: 'Code', visible: this.state.visible }),
                _react2.default.createElement(FormatButton, { label: (0, _languageHandler._t)("Quote"), onClick: function onClick() {
                        return _this2.props.onAction("quote");
                    }, icon: 'Quote', shortcut: this.props.shortcuts.quote, visible: this.state.visible })
            );
        }
    }, {
        key: 'showAt',
        value: function showAt(selectionRect) {
            this.setState({ visible: true });
            var parentRect = this._formatBarRef.parentElement.getBoundingClientRect();
            this._formatBarRef.style.left = selectionRect.left - parentRect.left + 'px';
            // 12 is half the height of the bar (e.g. to center it) and 16 is an offset that felt ok.
            this._formatBarRef.style.top = selectionRect.top - parentRect.top - 16 - 12 + 'px';
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.setState({ visible: false });
        }
    }]);
    return MessageComposerFormatBar;
}(_react2.default.PureComponent); /*
                                  Copyright 2019 The Matrix.org Foundation C.I.C.
                                  
                                  Licensed under the Apache License, Version 2.0 (the "License");
                                  you may not use this file except in compliance with the License.
                                  You may obtain a copy of the License at
                                  
                                      http://www.apache.org/licenses/LICENSE-2.0
                                  
                                  Unless required by applicable law or agreed to in writing, software
                                  distributed under the License is distributed on an "AS IS" BASIS,
                                  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                  See the License for the specific language governing permissions and
                                  limitations under the License.
                                  */

MessageComposerFormatBar.propTypes = {
    onAction: _propTypes2.default.func.isRequired,
    shortcuts: _propTypes2.default.object.isRequired
};
exports.default = MessageComposerFormatBar;

var FormatButton = function (_React$PureComponent2) {
    (0, _inherits3.default)(FormatButton, _React$PureComponent2);

    function FormatButton() {
        (0, _classCallCheck3.default)(this, FormatButton);
        return (0, _possibleConstructorReturn3.default)(this, (FormatButton.__proto__ || (0, _getPrototypeOf2.default)(FormatButton)).apply(this, arguments));
    }

    (0, _createClass3.default)(FormatButton, [{
        key: 'render',
        value: function render() {
            var InteractiveTooltip = _index2.default.getComponent('elements.InteractiveTooltip');
            var className = 'mx_MessageComposerFormatBar_button mx_MessageComposerFormatBar_buttonIcon' + this.props.icon;
            var shortcut = void 0;
            if (this.props.shortcut) {
                shortcut = _react2.default.createElement(
                    'div',
                    { className: 'mx_MessageComposerFormatBar_tooltipShortcut' },
                    this.props.shortcut
                );
            }
            var tooltipContent = _react2.default.createElement(
                'div',
                { className: 'mx_MessageComposerFormatBar_buttonTooltip' },
                _react2.default.createElement(
                    'div',
                    null,
                    this.props.label
                ),
                shortcut
            );

            return _react2.default.createElement(
                InteractiveTooltip,
                { content: tooltipContent, forceHidden: !this.props.visible },
                _react2.default.createElement('span', { 'aria-label': this.props.label,
                    role: 'button',
                    onClick: this.props.onClick,
                    className: className })
            );
        }
    }]);
    return FormatButton;
}(_react2.default.PureComponent);

FormatButton.propTypes = {
    label: _propTypes2.default.string.isRequired,
    onClick: _propTypes2.default.func.isRequired,
    icon: _propTypes2.default.string.isRequired,
    shortcut: _propTypes2.default.string,
    visible: _propTypes2.default.bool
};
module.exports = exports['default'];
//# sourceMappingURL=MessageComposerFormatBar.js.map